<template>
  <b-modal
    :id="idModal"
    :ref="idModal"
    size="xl"
    body-classes="p-0"
    @hidden="reseteaValores"
    @show="cargaInicial"
  >
    <b-form>
      <h6 class="heading-small text-muted">
        Datos
        {{ tipoFormulario == 1 ? "Padre" : "Madre" }}
      </h6>
      <hr class="mt-0 mb-4" />
      <div>
        <b-row>
          <b-col>
            <base-input
              type="text"
              label="Nombre"
              placeholder="Nombre"
              :disabled="esVisible"
              v-model="progenitorModal.nombre"
            >
            </base-input>
          </b-col>

          <b-col>
            <base-input
              type="text"
              label="Primer apellido"
              placeholder="Primer apellido"
              :disabled="esVisible"
              v-model="progenitorModal.apellido1"
            >
            </base-input>
          </b-col>
          <b-col>
            <base-input
              type="text"
              label="Segundo apellido"
              placeholder="Segundo apellido"
              :disabled="esVisible"
              v-model="progenitorModal.apellido2"
            >
            </base-input>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <base-input
              type="date"
              label="Fecha de Nacimiento"
              locale="es"
              :disabled="esVisible"
              v-model="progenitorModal.fecha_nacimiento"
            >
            </base-input>
          </b-col>
          <b-col>
            <base-input
              type="text"
              label="Numero de telefono"
              placeholder="Numero de telefono"
              :disabled="esVisible"
              v-model="progenitorModal.telefono"
            >
            </base-input>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <base-input
              type="text"
              label="Profesión"
              placeholder="Profesión"
              :disabled="esVisible"
              v-model="progenitorModal.profesion"
            >
            </base-input>
          </b-col>
        </b-row>
      </div>
    </b-form>
    <template #modal-footer>
      <div class="w-100">
        <b-button
          variant="primary"
          size="sm"
          class="float-right"
          @click="creaNuevoPadre()"
          :disabled="activaBoton"
        >
          Guardar
        </b-button>
      </div>
    </template>
  </b-modal>
</template>
<script>
export default {
  components: {},
  props: {
    progenitor: {
      default: {
        nombre: "",
        apellido1: "",
        apellido2: "",
        fecha_nacimiento: "",
        telefono: "",
        profesion: "",
        id: "",
      },
    },
    tipoFormulario: { defaul: undefined },
    idModal:{default:""}
  },
  data() {
    return {
      esVisible: false,
      progenitorModal: {
        nombre: "",
        apellido1: "",
        apellido2: "",
        fecha_nacimiento: "",
        telefono: "",
        profesion: "",
        id: "",
      },
    };
  },
  computed: {
    activaBoton() {
      if (
        this.progenitorModal.nombre == "" ||
        this.progenitorModal.nombre == undefined ||
        this.progenitorModal.apellido1 == "" ||
        this.progenitorModal.apellido1 == undefined
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    reseteaValores() {
      this.progenitorModal = {
        nombre: "",
        apellido1: "",
        apellido2: "",
        fecha_nacimiento: "",
        telefono: "",
        profesion: "",
        id: "",
      };
    },
    cargaInicial() {
      this.progenitorModal.nombre= this.progenitor.nombre;
      this.progenitorModal.apellido1= this.progenitor.apellido1;
      this.progenitorModal.apellido2= this.progenitor.apellido2;
      this.progenitorModal.fecha_nacimiento= this.progenitor.fecha_nacimiento;
      this.progenitorModal.telefono= this.progenitor.telefono;
      this.progenitorModal.profesion= this.progenitor.profesion;
      this.progenitorModal.id= this.progenitor.id;
    },
    creaNuevoPadre() {
      this.$emit("datosProgenitor", this.progenitorModal);
    },
  },
};
</script>
<style></style>
